import type { Job } from "@domain/job";
import type { Filter } from "@infra/interfaces/api/common";
import type { IJobs } from "@infra/interfaces/jobs/IJobs";

export interface JobsListUseCaseDeps {
	jobsApi: IJobs;
}

/**
 * Read path for the jobs list (JobsDashboardTable). A thin adapter over the
 * `IJobs` port; no business logic today, but lets VMs depend on a use case
 * instead of `API.Data.Jobs` directly so swap-in test/CLI implementations
 * just provide the port.
 */
export class JobsListUseCase {
	constructor(private readonly deps: JobsListUseCaseDeps) {}

	async loadByFilter(filter: Filter<Job>): Promise<Job[]> {
		return this.deps.jobsApi.getByFilter(filter);
	}
}
